export default __webpack_public_path__ + "static/media/basil.be00474e.jpg";